export enum ContentType {
    Grid,
    Raster,
    Flex,
    Canvas,
    Bootstrapgrid
}
